var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_62731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40Z",
    fill: "url(#paint0_linear_282_62731)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3962 52.7481L21.1039 40.662C19.558 39.0074 19.6467 36.3895 21.3013 34.8435C22.956 33.2976 25.5739 33.3865 27.1198 35.0409L35.8302 44.3635L49.6176 31.4815C49.7416 31.3655 49.8711 31.2593 50.0051 31.1615L56.4888 25.1038C58.1434 23.5578 60.7615 23.6468 62.3073 25.3015C63.8532 26.9559 63.7643 29.574 62.1099 31.12L42.3071 49.6223L42.2859 49.5997L35.4359 56L32.3962 52.7481Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_62731",
    x1: 11.7156,
    y1: 11.7156,
    x2: 68.2844,
    y2: 68.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54D561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA71A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_62731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.1b8fe3cb724bfac641667642c80feda1.svg";
export { ForwardRef as ReactComponent };